import { z } from 'zod';
import { DecimalJSLikeSchema } from "../inputTypeSchemas/DecimalJsLikeSchema"
import { isValidDecimalInput } from "../inputTypeSchemas/isValidDecimalInput"

/////////////////////////////////////////
// CODE ENFORCEMENT CASE SCHEMA
/////////////////////////////////////////

export const CodeEnforcementCaseSchema = z.object({
  caseId: z.number().int(),
  cityId: z.number().int(),
  codeEnforcementType: z.string(),
  reportedById: z.number().int(),
  reportedByType: z.string(),
  dateEntered: z.coerce.date(),
  enteredById: z.number().int(),
  enforceStatus: z.string(),
  otherType: z.string(),
  description: z.string(),
  propertyId: z.number().int(),
  propertyAPN: z.string(),
  propertyCoord: z.string(),
  propertyCoordGPS: z.string().nullable(),
  propertyNumUnits: z.string(),
  propertyStatus: z.string(),
  ownerId: z.number().int(),
  dateClosed: z.coerce.date(),
  closedById: z.number().int(),
  reasonClosed: z.string(),
  assignedToId: z.number().int(),
  dateNextReminder: z.coerce.date(),
  dateDue: z.coerce.date(),
  dateLastInspection: z.coerce.date(),
  dateFirstInspection: z.coerce.date(),
  dateEarliestDue: z.coerce.date(),
  dateHearing: z.coerce.date(),
  timeHearing: z.string(),
  enforceZone: z.string(),
  feesDue: z.union([z.number(),z.string(),DecimalJSLikeSchema,]).refine((v) => isValidDecimalInput(v), { message: "Field 'feesDue' must be a Decimal. Location: ['Models', 'CodeEnforcementCase']",  }),
  feesCharged: z.union([z.number(),z.string(),DecimalJSLikeSchema,]).refine((v) => isValidDecimalInput(v), { message: "Field 'feesCharged' must be a Decimal. Location: ['Models', 'CodeEnforcementCase']",  }),
  feesPaid: z.union([z.number(),z.string(),DecimalJSLikeSchema,]).refine((v) => isValidDecimalInput(v), { message: "Field 'feesPaid' must be a Decimal. Location: ['Models', 'CodeEnforcementCase']",  }),
  totalHours: z.union([z.number(),z.string(),DecimalJSLikeSchema,]).refine((v) => isValidDecimalInput(v), { message: "Field 'totalHours' must be a Decimal. Location: ['Models', 'CodeEnforcementCase']",  }),
  priority: z.string(),
  gasMeter: z.string(),
  electricMeter: z.string(),
  electricHazards: z.string(),
  gasHazards: z.string(),
  cartStore: z.string(),
  numberCarts: z.number().int(),
  cartLocations: z.string(),
  citationNum: z.string(),
  permitNum: z.string(),
  businessName: z.string(),
  businessLicense: z.string(),
  driversLicense: z.string(),
  dob: z.string(),
  projectName: z.string(),
  subdivision: z.string(),
  classification: z.string(),
  subClassification: z.string(),
  dateCertified: z.coerce.date(),
  flag1: z.number().int(),
  flag2: z.number().int(),
  flag3: z.number().int(),
  flag4: z.number().int(),
  displayId: z.string(),
  primaryImageId: z.number().int(),
  notPublic: z.number().int(),
  externalId: z.string().nullable(),
  dateLastUpdated: z.coerce.date(),
  rowTimestamp: z.coerce.date(),
})

export type CodeEnforcementCase = z.infer<typeof CodeEnforcementCaseSchema>

export default CodeEnforcementCaseSchema;
